/* eslint-disable no-loop-func */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import * as dispatchCrudApi from '../../../api/CRUD/DispatchCRUD'
import Utils from "../../../utils/utils";

import { ParseResult } from "../../../utils/interfaces";


interface ApiCallArgs {
  data: any,
  path: string,
  method: string,
  type: any,
}

interface InitState {
  isLoading: boolean,
  data: any,
  url: any,
  type: any,
  error: any,

  proformaJobId: any,
  proformaStatus: any,
  proformaFile: any,

  log: any,
}


function NewReducer() {
  const name = 'publicIframe';


  const initialState: InitState = {
    isLoading: false,
    data: null,
    url: null,
    type: 0,
    error: null,

    proformaJobId: null,
    proformaStatus: null,
    proformaFile: null,

    log: null,
  };


  const reducers = {
    start: (state: InitState) => {
      state.isLoading = true;
      state.data = null;
      state.url = null;
      state.type = 0;
    },
    finish: (state: InitState, action: PayloadAction<{ data: any, url: any, type: any, error: string }>) => {
      let data = (action.payload && action.payload.data) ? action.payload.data : null;
      let url = (action.payload && action.payload.url) ? action.payload.url : null;
      let type = (action.payload && action.payload.type) ? action.payload.type : 0;
      let error = (action.payload && action.payload.error) ? action.payload.error : null;

      state.data = data;
      state.url = url;
      state.type = type;
      state.error = error;
      state.isLoading = false;
    },
    
    startLog: (state: InitState) => {
      state.isLoading = true;
      state.log = null;
    },
    finishLog: (state: InitState, action: PayloadAction<any>) => {
      let data = (action.payload) ? action.payload : null;

      state.log = data;
      state.isLoading = false;
    },

    startProformaGetByToken: (state: InitState) => {
      state.isLoading = true;
      state.proformaJobId = null;
      state.proformaStatus = null;
      state.proformaFile = null;
    },
    finishProformaGetByToken: (state: InitState, action: PayloadAction<{ jobId: any, status: any, file: any, url: any }>) => {
      let jobId = action.payload?.jobId || null;
      let status = action.payload?.status || null;
      let file = action.payload?.file || null;
      let url = action.payload?.url || null;
      
      state.proformaJobId = jobId;
      state.proformaStatus = status;
      state.proformaFile = file;
      state.url = url;
      state.isLoading = false;
    },

    startProformaAcceptDecline: (state: InitState) => {
      state.isLoading = true;
    },
    finishProformaAcceptDecline: (state: InitState) => {
      state.isLoading = false;
    },
  };


  const apis = {
    callPreviewApi: (params: ApiCallArgs) => async (dispatch: any) => {
      dispatch(actions.start());

      let apiCall = dispatchCrudApi.createApi;
      if(params.method === 'get'){
        apiCall = dispatchCrudApi.readApi;
      }

      await apiCall(params.data, params.path).then(result => {
        let data = result.data;
        let url = '';
        let error = null;

        try {
          if(data){
            url = window.URL.createObjectURL(new Blob([Utils.getUint8Array(data)], {type: 'application/pdf'}));
          }
          error = null;
        } catch(e){
          error = data;
        }
        
        dispatch(actions.finish({ data, url, type: params.type, error }));
      }).catch(error => {
        let res: ParseResult = {
          isError: false,
          errorMessage: null,
          status: null,
        };

        Utils.parseErrorTS(error, (result: ParseResult): void => {
          res = result
        });
        
        let err = (res && res.errorMessage && res.errorMessage.error && res.errorMessage.error != '') ? res.errorMessage.error : null;
        if(res.isError && err){
          Utils.toast(err, 'error');
        }
        
        dispatch(actions.finish({ data: null, url: null, type: params.type, error: err }));
      });
    },

    callEmailLogApi: (params: any) => async (dispatch: any) => {
      dispatch(actions.startLog());

      await dispatchCrudApi.readApi(params, 'job/email-log').then(result => {
        let data = result.data;

        dispatch(actions.finishLog(data));
      }).catch(error => {
        let res: ParseResult = {
          isError: false,
          errorMessage: null,
          status: null,
        };

        Utils.parseErrorTS(error, (result: ParseResult): void => {
          res = result
        });
        
        let err = (res && res.errorMessage && res.errorMessage.error && res.errorMessage.error != '') ? res.errorMessage.error : null;
        if(res.isError && err){
          Utils.toast(err, 'error');
        }
        
        dispatch(actions.finishLog(null));
      });
    },

    callProformaGetByTokenApi: (params: string, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startProformaGetByToken());

      await dispatchCrudApi.createApi(params, 'job/proforma/get-by-token').then(result => {
        let data = result.data;
        let error = null;

        let jobId = data?.jobId || null;
        let status = data?.status || null;
        let file = data?.file || null;

        let url = '';
        try {
          if(file){
            url = window.URL.createObjectURL(new Blob([Utils.getUint8Array(file)], {type: 'application/pdf'}));
          }
          error = null;
        } catch(e){
          error = data;
        }
        
        callback(true, data);
        dispatch(actions.finishProformaGetByToken({ jobId: jobId, status: status, file: file, url: url }));
      }).catch(error => {
        let res: ParseResult = {
          isError: false,
          errorMessage: null,
          status: null,
        };

        Utils.parseErrorTS(error, (result: ParseResult): void => {
          res = result
        });
        
        let err = (res && res.errorMessage && res.errorMessage.error && res.errorMessage.error != '') ? res.errorMessage.error : null;
        if(res.isError && err){
          Utils.toast(err, 'error');
        }
        
        callback(false, null);
        dispatch(actions.finishProformaGetByToken({ jobId: null, status: null, file: null, url: null }));
      });
    },

    callProformaAcceptApi: (params: string, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startProformaAcceptDecline());

      await dispatchCrudApi.createApi(params, 'job/proforma/accept').then(result => {
        let data = result.data;
        
        callback(true, data);
        dispatch(actions.finishProformaAcceptDecline());
      }).catch(error => {
        let res: ParseResult = {
          isError: false,
          errorMessage: null,
          status: null,
        };

        Utils.parseErrorTS(error, (result: ParseResult): void => {
          res = result
        });
        
        let err = (res && res.errorMessage && res.errorMessage.error && res.errorMessage.error != '') ? res.errorMessage.error : null;
        if(res.isError && err){
          Utils.toast(err, 'error');
        }
        
        callback(false, null);
        dispatch(actions.finishProformaAcceptDecline());
      });
    },

    callProformaDeclineApi: (params: string, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startProformaAcceptDecline());

      await dispatchCrudApi.createApi(params, 'job/proforma/decline').then(result => {
        let data = result.data;
        
        callback(true, data);
        dispatch(actions.finishProformaAcceptDecline());
      }).catch(error => {
        let res: ParseResult = {
          isError: false,
          errorMessage: null,
          status: null,
        };

        Utils.parseErrorTS(error, (result: ParseResult): void => {
          res = result
        });
        
        let err = (res && res.errorMessage && res.errorMessage.error && res.errorMessage.error != '') ? res.errorMessage.error : null;
        if(res.isError && err){
          Utils.toast(err, 'error');
        }
        
        callback(false, null);
        dispatch(actions.finishProformaAcceptDecline());
      });
    },
  };


  const { reducer, actions } = createSlice({
    name,
    initialState,
    reducers,
  });


  return {
    reducer,
    ...actions,
    ...apis,
  };
}


export default NewReducer();